
import request from "@/services/axios";
import { url } from "@/services/api";
// const url = "http://192.168.88.140:15001"

export default {
    // 通过路由地址获取在线表单字段信息
    getToolOnlFieldInfo(params) {
        return request({
            url: url + '/tool/onl/fieldInfo/' + params.path,
            method: 'get',
            params: params
        })
    },
    // 通过路由地址查询表单数据
    getToolOnlQueryPage(data) {
        return request({
            url: url + '/tool/onl/queryPageByPath',
            method: 'post',
            data: data
        })
    },


    // 新增表单数据
    AddToolOnlTableInfo(data) {
        return request({
            url: url + '/tool/onl/insertTableInfo',
            method: 'post',
            data: data
        })
    },
    // 修改表单数据
    UpdateToolOnlTableInfo(data) {
        return request({
            url: url + '/tool/onl/updateTableInfo',
            method: 'post',
            data: data
        })
    },
    // 删除表单数据
    DelToolOnlTableInfo(data) {
        return request({
            url: url + '/tool/onl/deleteTableInfo',
            method: 'post',
            data: data
        })
    },

}